<template>
    <el-card>
        <el-tabs v-model="activeName">
            <el-tab-pane :label="$t('Other.MyProfile.change_password')" name="first" :lazy="true">
                <div class="my-pofile-center flex justify-center">
                    <el-form
                        :model="form"
                        :rules="rules"
                        ref="form"
                        class="my-pofile-desc"
                        label-position="left"
                        label-width="90px">
                            <el-form-item :label="$t('Staff.login_count')" prop="email">
                                <span>{{ form.account }}</span>
                            </el-form-item>
                            <el-form-item :label="$t('Other.MyProfile.originalpassword')" prop="oldPassword">
                                <el-input
                                    type="password"
                                    v-model.trim="form.oldPassword"
                                    style="width: 470px;"
                                >
                                </el-input>
                            </el-form-item>
                            <el-form-item :label="$t('Other.MyProfile.newpassword')" prop="newPassword">
                                <el-input
                                    type="password"
                                    v-model.trim="form.newPassword"
                                    style="width: 470px;"
                                >
                                </el-input>
                            </el-form-item>
                            <div class="w-full mt1" style="margin-left: 90px;">
                                <el-button
                                    type="primary"
                                    @click="submit"
                                    :loading="isBtnLoading">
                                    {{ $t('Message.confirm') }}
                                </el-button>
                            </div>
                        </el-form>
                </div>
            </el-tab-pane>
        </el-tabs>
    </el-card>
</template>

<script>
import { Tabs, TabPane } from 'element-ui';

export default {
    components: {
        ElTabs: Tabs,
        ElTabPane: TabPane,
    },
    props: [],
    data() {
        let validatePassword = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('Other.MyProfile.import_newpass')));
            } else if (value.length < 6) {
                callback(new Error(this.$t('Other.MyProfile.not_six_newpass')));
            } else {
                callback();
            }
        };
        return {
            activeName: 'first',
            form: {
                account: this.$store.state.my.account,
                oldPassword: null,
                newPassword: null,
            },
            rules: {
                account: [
                    { required: true, message: this.$t('Fill.login_count') },
                ],
                oldPassword: [
                    { required: true, message: this.$t('Other.MyProfile.import_originalpassword') },
                ],
                newPassword: [
                    { validator: validatePassword, required: true, },
                ],
            },
            isBtnLoading: false,
        };
    },
    methods: {
        submit() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                this.isBtnLoading = true;
                API.put('my/password', this.form)
                .then(res => {
                    sessionStorage.clear();
                    $ele.$message.success(this.$t('Login.message'));
                    setTimeout(() => {
                        this.$store.dispatch('getMy', null, false);
                    }, 300);
                })
                .finally(() => { this.isBtnLoading = false; });
            });
        },
    },
};
</script>

<style lang="scss">
.my-pofile-center {
    width: 100%;
    min-height: 100vh;
    margin-top: 70px;
}
</style>
